import type { FollowUpChanges } from '@/modules/infringements/components/infringement-follow-up'
import { useOnErrorAuto } from '@/utils/hooks'
import { useMutation } from '@apollo/client'
import { PATCH_TACHOGRAPH_INFRINGEMENT } from '../mutations'

export function usePatchTachographInfringement(id: string) {
  const onErrorAuto = useOnErrorAuto()
  const [patch, { loading }] = useMutation(PATCH_TACHOGRAPH_INFRINGEMENT, {
    awaitRefetchQueries: true,
    refetchQueries: ['TachographInfringement', 'AllCombinedInfringements'],
    onError: onErrorAuto(),
  })
  return {
    loading,
    onPatch: (changes: FollowUpChanges) =>
      patch({ variables: { id, ...changes } }),
  }
}
